import { render } from "./AdminDetails.vue?vue&type=template&id=79cc16f9"
import script from "./AdminDetails.vue?vue&type=script&lang=js"
export * from "./AdminDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__